const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

function initDreamHero(hero) {
  if (hero.dataset.dreamReady === 'true') return;
  hero.dataset.dreamReady = 'true';

  let frame = 0;
  hero.addEventListener('pointermove', (event) => {
    if (REDUCED_MOTION.matches || event.pointerType === 'touch') return;
    if (frame) cancelAnimationFrame(frame);

    frame = requestAnimationFrame(() => {
      const bounds = hero.getBoundingClientRect();
      const x = ((event.clientX - bounds.left) / bounds.width) * 100;
      const y = ((event.clientY - bounds.top) / bounds.height) * 100;
      hero.style.setProperty('--dream-x', `${Math.max(8, Math.min(92, x))}%`);
      hero.style.setProperty('--dream-y', `${Math.max(12, Math.min(88, y))}%`);
    });
  });

  const shiftButton = hero.querySelector('[data-dream-shift]');
  shiftButton?.addEventListener('click', () => {
    const isShifted = hero.classList.toggle('is-shifted');
    shiftButton.setAttribute('aria-pressed', String(isShifted));
    shiftButton.querySelector('[data-dream-shift-label]').textContent = isShifted
      ? 'Return to waking'
      : 'Shift the dream';
  });
}

function initDreamReveals(root = document) {
  const targets = root.querySelectorAll('[data-dream-reveal]:not([data-dream-observed])');
  if (!targets.length) return;

  if (REDUCED_MOTION.matches || !('IntersectionObserver' in window)) {
    targets.forEach((target) => target.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  targets.forEach((target) => {
    target.dataset.dreamObserved = 'true';
    observer.observe(target);
  });
}

function initDreamProduct(host) {
  if (!host || host.dataset.dreamReady === 'true') return;
  host.dataset.dreamReady = 'true';

  const form = host.querySelector('.mjm-product-form');
  if (!form) return;

  const select = form.querySelector('.mjm-variant-select');
  const price = host.querySelector('[data-price]');
  const radios = [...form.querySelectorAll('[data-mjm-option]')];
  if (!select || !radios.length) return;

  function currentValues() {
    const values = {};
    radios.forEach((radio) => {
      if (radio.checked) values[Number(radio.dataset.optionIndex)] = radio.value;
    });
    return values;
  }

  function syncVariant() {
    const values = currentValues();
    let match = null;

    [...select.options].forEach((option) => {
      if (option.disabled) return;
      const option1 = option.dataset.option1 || '';
      const option2 = option.dataset.option2 || '';
      const option3 = option.dataset.option3 || '';
      if ((values[0] || '') === option1 && (values[1] || '') === option2 && (values[2] || '') === option3) {
        match = option;
      }
    });

    if (!match) return;
    select.value = match.value;
    if (price) {
      price.replaceChildren();
      price.append(match.dataset.price);
      if (match.dataset.compare && match.dataset.compare !== match.dataset.price) {
        const compare = document.createElement('s');
        compare.textContent = match.dataset.compare;
        price.append(' ', compare);
      }
    }

    // Swap hero media to match the selected color option
    const colorOption = radios.find((radio) => Number(radio.dataset.optionIndex) === 0 && radio.checked);
    if (colorOption) {
      const color = colorOption.value;
      const stage = host.querySelector('[data-media-stage]');
      const map = host.querySelector('[data-media-map]');
      if (stage && map) {
        const entry = [...map.querySelectorAll('[data-media-color]')].find(
          (el) => el.dataset.mediaColor.toLowerCase() === color.toLowerCase()
        );
        if (entry) {
          const img = stage.querySelector('img');
          if (img) {
            img.src = entry.dataset.mediaSrc;
            if (entry.dataset.mediaAlt) img.alt = entry.dataset.mediaAlt;
          }
        }
      }
    }
  }

  radios.forEach((radio) => radio.addEventListener('change', syncVariant));
  syncVariant();
}

function initExternalNavLinks() {
  // Static pass for crawlers/a11y — attribute may be wiped by Shopify hydration.
  document.querySelectorAll('#header-group a, nav a, footer a').forEach((link) => {
    try {
      const url = new URL(link.href, window.location.origin);
      if (url.hostname !== window.location.hostname) {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener');
      }
    } catch (error) {
      // Ignore malformed hrefs; leave the link as-is.
    }
  });

  // Delegated pass — guarantees new-tab behavior even after section re-renders.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('#header-group a[href], nav a[href], footer a[href]');
    if (!link) return;

    let url;
    try {
      url = new URL(link.getAttribute('href'), window.location.origin);
    } catch (error) {
      return;
    }

    if (url.hostname === window.location.hostname) return;

    event.preventDefault();
    window.open(url.href, '_blank', 'noopener');
  });
}

function initDreamscape(root = document) {
  root.querySelectorAll('[data-dream-hero]').forEach(initDreamHero);
  root.querySelectorAll('[data-dream-product]').forEach(initDreamProduct);
  initExternalNavLinks();
  initDreamReveals(root);
}

document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initDreamscape());
} else {
  initDreamscape();
}

document.addEventListener('shopify:section:load', (event) => initDreamscape(event.target));

